export default function FormatItemDate (props)  {
    let date = new Date( props.date )
    return date.toLocaleString("ru", {  hour: 'numeric', minute: 'numeric'})
}